// extracted by mini-css-extract-plugin
export default {"recos":"D6-z","productCardOverride":"E6-z","rowHasBadge":"F6-z"};